import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';

import OptionsButton from 'common/components/options-button';
import DeleteButton from 'common/components/delete-button';

@inject('songsStore', 'artistStore')
@observer
class SongOptions extends React.Component {
	render () {
		const { songID, songsStore, optionsTheme = 'light' } = this.props;

		return (
			<OptionsButton menuOnLeft onClick={ this.onClick } className={ `list-options left ${ optionsTheme }` }>
				{
					songID === songsStore.activeSongRowID ?
						this.renderOptions() : null
				}
			</OptionsButton>
		);
	}

	renderOptions () {
		return (
			<div className="cell auto list-options-menu">
				{
					this.renderFullPreviewOptions()
				}

				{
					this.renderOptionsButton({
						icon: 'download',
						label: 'Download Song',
						onClick: this.onDownloadClick
					})
				}

				<DeleteButton
					warningText="Really delete this song?"
					onDeleteClick={ this.onDeleteClick }
					onConfirmClick={ this.onConfirmClick }
					onCancelClick={ this.onCancelClick }>
						<button className="button secondary clear margin-bottom-0">
							<span className="fas fa-trash"></span> Delete Song
						</button>
				</DeleteButton>
			</div>
		);
	}

	renderFullPreviewOptions () {
		const { song } = this.props;
		const icon = 'arrow-up';

		if (song.isFullPreview) {

			return this.renderOptionsButton({
				icon: 'arrow-down',
				label: 'Remove from Full Preview',
				onClick: this.onRemoveFullPreviewClick
			});
		}

		return (
			<div>
				{
					[1, 2, 3].map((position) => (
						this.renderOptionsButton({
							icon,
							position,
							onClick: this.onFullPreviewPositionClick,
							label: `Make Full Preview #${position}`,
							attrs: {
								'data-position': position
							}
						})
					))
				}
			</div>
		);
	}

	@autobind
	renderOptionsButton ({ icon, position, onClick, label, attrs = {} }) {
		return (
			<div key={ position }>
				<button
					{ ...attrs }
					onClick={ onClick }
					className="button secondary clear margin-bottom-0">
						<span className={ `fas fa-${icon}` }></span> { label }
				</button>
			</div>
		);
	}

	@autobind
	onClick (evt) {
		const { songsStore, songID } = this.props;
		songsStore.activeSongRowID = (songsStore.activeSongRowID === songID) ? null : songID;

		evt.stopPropagation();
	}

	@autobind
	onDownloadClick (evt) {
		const { song } = this.props;
		const songPath = `/assets/public/s3/song/${song.file}`;
		window.location.href = songPath;
		this.clearActiveSong();
	}

	@autobind
	onDeleteClick () {
		console.log('[onDeleteClick]');
	}

	@autobind
	onConfirmClick () {
		const { songsStore, song } = this.props;
		songsStore.deleteItem(song);

		this.clearActiveSong();
	}

	@autobind
	onCancelClick () {
		this.clearActiveSong();
	}

	@autobind
	onFullPreviewPositionClick ({ target }) {
		const { song, songsStore } = this.props;
		songsStore.updateFullPreviewPosition(song, target.dataset.position);
		this.clearActiveSong();
	}

	@autobind
	onRemoveFullPreviewClick () {
		const { song, songsStore } = this.props;
		songsStore.removeFullPreview(song);
		this.clearActiveSong();
	}

	clearActiveSong () {
		this.props.songsStore.activeSongRowID = null;
	}
}

export default SongOptions;
